import activitiesTypes from "./activities.types";
export default {
  fetchTierActivitiesLoading: state =>
    state.type === activitiesTypes.FETCH_TIER_ACTIVITIES_REQUEST,
  fetchTierActivitiesSuccess: state =>
    state.type === activitiesTypes.FETCH_TIER_ACTIVITIES_SUCCESS,
  fetchTierActivitiesFailed: state =>
    state.type === activitiesTypes.FETCH_TIER_ACTIVITIES_FAILED,

  fetcActionActivitiesLoading: state =>
    state.type === activitiesTypes.FETCH_ACTION_ACTIVITIES_REQUEST,
  fetchActionActivitiesSuccess: state =>
    state.type === activitiesTypes.FETCH_ACTION_ACTIVITIES_SUCCESS,
  fetchActionActivitiesFailed: state =>
    state.type === activitiesTypes.FETCH_ACTION_ACTIVITIES_FAILED
};
